export let LABStatus = [
{
  name: '委托单审核',
  icon: 'icon-weituodandaishenhe',
  background: require('@/assets/images/back-chuangjiandingdan.png'),
  action: 'BILL_CHECKED',
  otherParams:{billStatusEnum:'BILL_CREATED'},
  permisson: 'PERM_LAB_CREATE_ORDER'
}, 
// {
//   name: '样品接收',
//   icon: 'icon-yangbenjieshou',
//   background: require('@/assets/images/back-yangbenjieshou.png'),
//   action: 'BILL_RECEIVE',
//   otherParams:{billStatusEnum:'BILL_BACK'},
//   permisson: 'PERM_LAB_SAMPLE_RECEIVE'
//   },
  {
  name: '委托单分派',
  icon: 'icon-weituodandaifenpai',
  background: require('@/assets/images/back-weituodanfenpai.png'),
  action: 'BILL_ASSIGN',
  otherParams:{billStatusEnum:'BILL_RECEIVE'},
  permisson: 'PERM_LAB_DNA_READY'
},
{
  name: '委托单延期交付',
  icon: 'icon-weituodandaijiaofu',
  background: require('@/assets/images/back-yanqijiaofu.png'),
  action: 'BILL_DELAY',
  otherParams:{billStatusEnum:'BILL_ASSIGN'},
  permisson: 'PERM_LAB_DNA_READY'
}
// , {
//   name: '样本提取',
//   icon: 'icon-hesuantiqu',
//   background: require('@/assets/images/back-hesuantiqu.png'),
//   action: 'LAB_DNA_READY',
//   permisson: 'PERM_LAB_DNA_READY'
// }, {
//   name: '样本排版',
//   icon: 'icon-yangbenpaiban',
//   background: require('@/assets/images/back-yangbenpaiban.png'),
//   action: 'CHIP_SLOT',
//   permisson: 'PERM_LAB_CHIP_SLOT'// 'PERM_CHIP_SLOT'
// }, {
//   name: '检测实验',
//   icon: 'icon-shangjijiance',
//   background: require('@/assets/images/back-jianceshiyan.png'),
//   action: 'LAB_DNA_TESTED',
//   permisson: 'PERM_LAB_DNA_TESTED'// 'PERM_LAB_DNA_TESTED'
// }, {
//   name: '数据质控',
//   icon: 'icon-shujuzhikong',
//   background: require('@/assets/images/back-shujuzhikong.png'),
//   action: 'DATA_ANALYSISED',
//   permisson: 'PERM_LAB_DATA_ANALYSISED'
// }
]
export let TaskStatus = [
  {
    name: '样品领样',
    icon: 'icon-yangpindailingyang',
    background: require('@/assets/images/piliang/back-chuangjiandingdan.png'),
    action: 'ORDER_GET',
    otherParams:{status:'PRODUCTION_TASK_CREATED'},
    permisson: 'PERM_LAB_CREATE_ORDER'
  }, 
  {
    name: '提交原始记录',
    icon: 'icon-yangpinjiancezhong',
    background: require('@/assets/images/piliang/back-yangbenjieshou.png'),
    action: 'ORDER_EXAM',
    otherParams:{status:'PRODUCTION_TASK_GET',orderStatusResult:'CONFIRM_EXAM_DATA'},
    permisson: 'PERM_LAB_SAMPLE_RECEIVE'
  }, {
    name: '确认接收原始记录',
    icon: 'icon-yangpindaibaogao',
    background: require('@/assets/images/piliang/back-hesuantiqu.png'),
    action: 'REPORT_CREATE',
    otherParams:{status:'PRODUCTION_TASK_EXAM',isReceiveExamData:false,orderStatusResult:'RECEIVE_EXAM_DATA'},
    permisson: 'PERM_LAB_DNA_READY'
  }, {
    name: '确认编制报告',
    icon: 'icon-yangpindaibaogao',
    background: require('@/assets/images/piliang/back-hesuantiqu.png'),
    action: 'REPORT_CREATE',
    otherParams:{status:'PRODUCTION_TASK_EXAM',isReceiveExamData:true,orderStatusResult:'REPORT_CREATED'},
    permisson: 'PERM_LAB_CHIP_SLOT'
  }, {
    name: '确认审核报告',
    icon: 'icon-yangpindaishenhe',
    background: require('@/assets/images/piliang/back-shenhebaogao.png'),
    action: 'REPORT_CHECKED',
    otherParams:{status:'PRODUCTION_TASK_REPORT'},
    permisson: 'PERM_LAB_DNA_TESTED'
  }, {
    name: '确认已归还',
    icon: 'icon-yangpindaiguihuan',
    background: require('@/assets/images/piliang/back-querenguihuan.png'),
    action: 'ORDER_BACK',
    otherParams:{status:'PRODUCTION_TASK_CHECK',isOrderBack:false,orderStatusResult: 'CONFIRM_ORDER_BACK'},
    permisson: 'PERM_LAB_DATA_ANALYSISED'
}, {
  name: '确认已回收',
  icon: 'icon-yangpindaiguihuan',
  background: require('@/assets/images/piliang/back-querenguihuan.png'),
  action: 'ORDER_BACK',
  otherParams:{status:'PRODUCTION_TASK_CHECK',isOrderBack:true,orderStatusResult: 'CONFIRM_ORDER_RECOVERY'},
  permisson: 'PERM_LAB_DATA_ANALYSISED'
}]
